export default __webpack_public_path__ + "static/media/logo.3f67a0a8.jpg";